import { View, ViewOpts, animate } from '@play-co/timestep-core/ui';
import { DOWNSCALE_FACTOR, downscale } from 'src/conf/scale';
import { ProgressBar } from 'src/game/components/shared/ProgressBar';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { SuperLollipopIcon } from './SuperLollipopIcon';
import sounds from 'src/lib/sounds';
import { getSuperLollipopWinStreakRequired } from 'src/replicant/superLollipop/superLollipop.getters';
import { user } from 'src/StateObserver';

export class SuperLollipopProgress extends View {
  private progressBar: ProgressBar;
  private label: LangBitmapFontTextView;
  private value = 0;

  constructor(opts: ViewOpts) {
    const width = downscale(734);
    const height = downscale(106);

    super({ ...opts, width, height });

    this.progressBar = new ProgressBar({
      superview: this,
      bgStyle: {
        image: 'assets/ui/superLollipop/shared/progress_base.png',
        width,
        height,
        scaleMethod: '3slice',
        sourceSlices: {
          horizontal: { left: 80, right: 80 },
          vertical: { top: 0, bottom: 0 },
        },
        imgScale: DOWNSCALE_FACTOR,
      },
      fillStyle: {
        image: 'assets/ui/superLollipop/shared/progress_fill.png',
        width: downscale(554),
        height: downscale(84),
        x: 10,
        y: 5,
        paddingRight: 15,
        scaleMethod: '3slice',
        sourceSlices: {
          horizontal: { left: 40, right: 40 },
          vertical: { top: 0, bottom: 0 },
        },
        imgScale: DOWNSCALE_FACTOR,
      },
      domain: [0, getSuperLollipopWinStreakRequired(user())],
    });

    this.progressBar.updateOpts({
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
    });
    this.progressBar.on('progress', this.updateProgress.bind(this));

    new SuperLollipopIcon({
      superview: this,
      x: this.style.width - 20,
      y: this.style.height / 2 - 3,
      scale: 1.25,
    });

    this.label = new LangBitmapFontTextView({
      superview: this,
      width: 100,
      height: 30,
      align: 'center',
      centerOnOrigin: true,
      size: 32,
      font: 'Title',
      color: '#FFFFFF',
      x: this.style.width * 0.5,
      y: this.style.height * 0.5 - 5,
    });
  }

  public setProgress(value: number) {
    value = Math.round(Math.min(value, this.progressBar.domain[1]));
    this.value = value;
    this.progressBar.progress = value;
    this.label.localeText = () => `${value}/${this.progressBar.domain[1]}`;
  }

  public animateProgress(value: number) {
    value = Math.round(Math.min(value, this.progressBar.domain[1]));
    this.value = value;
    this.progressBar.animateProgress(value, 3000, animate.linear);
  }

  private updateProgress(value: number) {
    value = Math.round(Math.min(value, this.progressBar.domain[1]));
    if (value < this.value) {
      sounds.playSound('puzzle-lose', 0.5);
    }
    this.value = value;
    this.label.updateOpts({
      localeText: () => `${value}/${this.progressBar.domain[1]}`,
    });
  }
}
